import createTypeDecorator from '../decorators/createTypeDecorator'
// import {
//   getStringLengthValidator,
// } from 'pw-validators'
// import {
//   formatBytesToBits,
//   formatBytes,
//   formatNumber
// } from 'pw-formatters'

export const BYTES = Symbol("schemer.types.BYTES")
export const BYTES_PER_SEC = Symbol("schemer.types.BYTES_PER_SEC")

export const bytes = createTypeDecorator(BYTES, {
  formatDisplay: val => val, //&& formatBytes(val, true),
  input: {
    // Megabytes, megabits, etc
    // unitOptions: ['B', 'kB', 'MB', 'GB', 'TB'],
    // validate: _.noop, // TODO
    // placeholder: "156 kB"
  },
  table: {
    width: 100
  }
})

export const bytesPerSec = createTypeDecorator(BYTES_PER_SEC, {
  formatDisplay: val => val, //&& formatBytesToBits(val, true),
  input: {
    // unitOptions: ['b/s', 'kb/s', 'Mb/s', 'Gb/s', 'Tb/s'], // Megabits/second, etc
    // validate: _.noop, // TODO
    // placeholder: "288 Mb/s"
  },
  table: {
    width: 100
  }
})